
if (typeof window._env_.REACT_APP_RUN_MODE == 'undefined') {
    window._env_.REACT_APP_RUN_MODE = import.meta.env.VITE_RUN_MODE;
}
let url = "";
if (import.meta.env.VITE_API_URL) {
    url = import.meta.env.VITE_API_URL;
} else {
    const origin = window.location.origin;
    // Any private/LAN IP or localhost → use Vite proxy (/api → localhost:7071)
    const isLocal =
        origin.includes("localhost") ||
        /https?:\/\/(10\.|172\.(1[6-9]|2[0-9]|3[01])\.|192\.168\.|100\.(6[4-9]|[7-9][0-9]|1([01][0-9]|2[0-7]))\.)/.test(origin);
    if (isLocal) {
        url = "/api";
    } else if (origin.includes("web.sizewall.com")) {
        console.log("Using production API URL https://api.sizewall.com/api");
        url = "https://api.sizewall.com/api";
    } else {
        url = "https://api.sizewall.com/api";
    }
}
export const PIPEDB_URL = url;

